import http from '@/http'

const API_PATH = 'auth/'

const state = {
  initialized: false,
  signedIn: false,
  user: null
}

const getters = {
  initialized: state => state.initialized,
  signedIn: state => state.signedIn,
  user: state => state.user
}

const mutations = {
  initialized(state) {
    state.initialized = true
  },
  signedIn(state, payload) {
    state.signedIn = payload
  },
  user(state, payload) {
    state.user = payload
  }
}

const actions = {
  async validate({ commit }) {
    await http.get(API_PATH + 'validate_token').then(response => {
      commit('signedIn', true)
      commit('user', response.data.data.attributes)
    }).catch(error => {
      if (!error.response || error.response.status != 401) {
        const customError = {
          response: {
            data: {
              errors: [
                '認証サーバとの通信にエラーが発生したため、認証情報の検証に失敗しました。'
              ]
            }
          }
        }
        commit('setHttpError', customError, { root: true })
      }
    }).then(() => {
      commit('initialized')
    })
  },
  async signIn({ commit }, payload) {
    await http.post(API_PATH + 'sign_in', payload).then(response => {
      commit('signedIn', true)
      commit('user', response.data.data.attributes)
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async signOut({ commit }) {
    await http.delete(API_PATH + 'sign_out').then(() => {
      commit('user', null)
      commit('signedIn', false)
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async signUp({ commit }, payload) {
    await http.post(API_PATH, payload).then(() => {
      commit('setHttpSuccess', '入力されたメールアドレスに確認用のメールを送信しました。メールに記載されたリンクをクリックしてアカウントの有効化をおこなって下さい。', { root: true })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async confirmation({ commit }, payload) {
    await http.post(API_PATH + 'confirmation', payload).then(response => {
      commit('signedIn', true)
      commit('user', response.data.data.attributes)
      let successMessage = payload.reconfirmation ? 'メールアドレスの変更確認が完了しました。' : 'アカウントの有効化が完了しました。'
      commit('setHttpSuccess', successMessage, { root: true })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async forgotPassword ({ commit }, payload) {
    await http.post(API_PATH + 'password', payload).then(() => {
      commit('setHttpSuccess', 'パスワード再設定用のメールを送信しました。メール内のリンクから新しいパスワードを設定して下さい。', { root: true })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async resetPassword({ commit }, payload) {
    await http.put(API_PATH + 'password', payload).then(response => {
      commit('signedIn', true)
      commit('user', response.data.data.attributes)
      commit('setHttpSuccess', 'パスワードの再設定が完了しました。', { root: true })
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  },
  async update({ state, commit }, payload) {
    const emailChanged = state.user.email != payload.email
    const params = JSON.stringify({
      user: payload
    })
    await http.put(API_PATH, params).then(response => {
      commit('user', response.data.data.attributes)
      if (emailChanged) {
        commit('setHttpSuccess', `入力されたメールアドレス(${payload.email})に変更確認用のメールを送信しました。メールに記載されたリンクをクリックしてメールアドレスの変更確認をおこなって下さい。`, { root: true })
      } else {
        commit('setHttpSuccess', '個人設定を更新しました。', { root: true })
      }
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
